import styled from "styled-components";

const HomeCounter = styled.div`
  text-align: center;
  color: rgb(255, 255, 255);
  font-weight: 600;
  font-size: 70px;
  font-family: sans-serif;
  margin-top: 0px;
  margin-bottom: 12px;
`

export default HomeCounter
